import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface ReferralShareLinks {
  whatsapp?: string
  telegram?: string
  twitter?: string
}

export interface ReferralStats {
  invitedCount?: number // تعداد ثبت‌نام‌شده‌ها با لینک شما
  successCount?: number // تعداد خرید اول موفق
  pendingCount?: number // ثبت‌نام‌شده بدون خرید
  rewardCredits?: number // مجموع اعتبار پاداش
}

export interface ReferralMe {
  code: string
  link: string
  share?: ReferralShareLinks
  stats?: ReferralStats
  note?: string
}

export interface InvitedUser {
  id: number
  email: string
  name?: string
  family?: string
  create_date?: string
}

export interface InvitedItem {
  invited: InvitedUser
  purchased: boolean
  status: 'REGISTERED' | 'PURCHASED'
  purchase_info?: { create_date?: string; payment_id?: string | number } | null
}

export interface UseInvited {
  id: number
  email: string
  name?: string
  family?: string
}

export interface UseItem {
  id: number
  create_date?: string
  Invited: UseInvited
  payment_id: number | string
}

export const referralApi = createApi({
  reducerPath: 'referralApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) headers.set('authorization', `Bearer ${token}`)
      return headers
    },
  }),
  tagTypes: ['referral'],
  endpoints: (builder) => ({
    me: builder.query<ReferralMe, void>({
      query: () => 'referral/me',
      providesTags: ['referral']
    }),
    invited: builder.query<InvitedItem[], void>({
      query: () => 'referral/invited',
      providesTags: ['referral']
    }),
    uses: builder.query<UseItem[], void>({
      query: () => 'referral/uses',
      providesTags: ['referral']
    }),
  }),
})

export const { useMeQuery: useReferralMeQuery, useInvitedQuery: useReferralInvitedQuery, useUsesQuery: useReferralUsesQuery } = referralApi
